import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TeamsState {
  activeTeams: string[];
  activeDeselectedCourses: string[];
  activeCourseNames?: string[];
  currentTeamCourseIds: string[]; // Current list of course ids for the selected teams (displayed in Report Settings Pane)
}

const initialState: TeamsState = {
  activeTeams: [],
  activeDeselectedCourses: [],
  currentTeamCourseIds: [],
};

export const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    setActiveTeams(state, action: PayloadAction<string[]>) {
      state.activeTeams = action.payload;
    },
    setActiveCourseNames(state, action: PayloadAction<string[]>) {
      state.activeCourseNames = action.payload;
    },
    setActiveDeselectedCourses(state, action: PayloadAction<string[]>) {
      state.activeDeselectedCourses = action.payload;
    },
    setCurrentTeamCourseIds(state, action: PayloadAction<string[]>) {
      state.currentTeamCourseIds = action.payload;
    },
  },
});

export const {
  setActiveTeams,
  setActiveDeselectedCourses,
  setActiveCourseNames,
  setCurrentTeamCourseIds,
} = teamsSlice.actions;
